import { ReactNode } from "react";

export type MessageType = "info" | "success" | "warn" | "danger";

interface Props {
  children: ReactNode;
  type: MessageType;
}

function typeToClasses(type: MessageType): string {
  switch (type) {
    case "info":
      return "bg-primary text-white";
    case "success":
      return "bg-primary-dark/80 text-white";
    case "warn":
      return "bg-yellow-400/95 text-black";
    case "danger":
      return "bg-white border border-accent text-accent";
  }
}

export default function SystemMessage({ children, type }: Props) {
  const classes = typeToClasses(type);

  return (
    <div className="absolute top-2 left-[50%] z-50 w-full min-w-[280px] max-w-[1280px] translate-x-[-50%]">
      <p
        className={`${classes} py-3 px-2 flex items-center justify-center h-[66px] text-sm font-bold text-center rounded-sm`}
      >
        {children}
      </p>
    </div>
  );
}
